/*
Author: LiuBo
Date: 2018-11-27
Desc: JFIT 网上交易公共方法
*/
import conf from "@/config/index";
import req from "@/assets/js/req";
import cache from "@/assets/js/cache";
import store from "@/store";
import Vue from "vue";
/* 系统常量
 */
let queryRate = null; // 费率查询定时器
let CommonConst = {
    // 基金状态
    FS_OnTrade: "0", // 交易
    FS_OnIssue: "1", // 发行
    FS_IssueSucc: "2", // 发行成功
    FS_IssueFail: "3", // 发行失败
    FS_OffTrade: "4", // 基金停止交易
    FS_OffBid: "5", // 停止申购
    FS_OffRedeem: "6", // 停止赎回
    FS_OnSetBal: "7", // 权益登记
    FS_OnDivdent: "8", // 红利发放
    FS_CloseFund: "9", // 基金封闭
    FS_EndFund: "a", // 基金终止
    // 收费类型
    ST_Before: "A", // 前收费
    ST_After: "B", // 后收费
    RISK_INFO: [{
        risk: "01",
        affordability: "低级",
        describe: "在基金投资过程中，保护本金不受损失和保持资产的流动性是您的首要目标。您对投资的态度是希望投资收益稳定，" +
                "不愿或不能承担高风险以换取高收益，通常不太在意资金是否有较大增值，追求稳定。"
    },
    {
        risk: "02",
        affordability: "中低级",
        describe: "稳定是您首要考虑的因素之一。在基金投资中，您希望在保证本金安全的基础上能有一些增值收入。追求较低的风险，" +
                "对投资回报的要求不是太高。"
    },
    {
        risk: "03",
        affordability: "中级",
        describe: "在基金投资的过程中，风险较小的情况下获得一定的收益是您主要的投资目的。您通常愿意使本金面临一定的风险，但在做投资" +
                "决定时，会仔细地对将要面临的风险进行认真的分析。总体来看，您愿意承受市场的平均风险。"
    },
    {
        risk: "04",
        affordability: "中高级",
        describe: "在基金投资中，您渴望有较高的投资收益，但又不愿承受较大的风险；可以承受一定的投资波动，但是希望自己的投资" +
                "风险小于市场的整体风险。您有较高的收益目标，且对风险有清醒的认识。"
    },
    {
        risk: "05",
        affordability: "高级",
        describe: "在基金投资中，您通常专注于投资的长期增值，并愿意为此承受较大的风险。短期的投资波动并不会对您造成大的影响，" +
                "追求超高的回报才是您关注的目标。"
    }
    ],
    FUND_HIGHRISK_INFO: "您已主动要求查看高于您风险等级的产品，根据中国证监会《证券期货投资者适当性管理办法》等监管法规规定，以下产品风险等级高于您风险承受能力，与您风险等级不匹配，可能产生投资风险，请谨慎投资。",
    FUND_RISK_INFO: "根据证券期货投资者适当性管理办法，产品列表已根据您的风险等级做筛选调整。"
};

/* 校验用户信息完善程度
 @return [Boolean] 返回需要进行的操作校验结果，true or false
 */
const userCheck = (info, cate, path) => {
    if (info.usertype !== "3" && info.usertype !== "4") return [];
    let infoCheckResult = [];
    // 检查结果四位数字
    // 交易密码
    let _obj = {};
    if (info.tradepwdexpired === "1" || info.tradepwdreset === "1") {
        _obj = {
            id: "0101",
            text: "您的交易密码已重置或过期，为了你的交易安全请修改交易密码",
            tit: "交易密码修改",
            name: ""
        };
        infoCheckResult.push(_obj);
    }
    // 风险评测
    if (info.riskexpired === "1") {
        _obj = {
            id: "0201",
            text: "您还未做风险评测或评测已过期，请先完善",
            tit: "风险评测",
            name: ""
        };
        infoCheckResult.push(_obj);
    }
    if (!info.birthdate.trim() ||
        !info.delivertype.trim() ||
        !info.address.trim() ||
        Vue.prototype.$util.isEmpty(info.livingaddressprovince) ||
        !info.country ||
        (info.benefisself === "0" && info.benefexpdate === "1") ||
        (info.certexpired === "1" && (path !== "/fund/sellfund" && path !== "/fund/ordersell" && path !== "/currencyfund/currencyredemption"))
    ) {
        if (info.certexpired === "1") {
            if (path !== "/fund/sellfund") {
                _obj = {
                    id: "0102",
                    text: "您的证件有效期已过期，请先修改证件有效期",
                    tit: "证件过期",
                    name: ""
                };
                infoCheckResult.push(_obj);
            }
        } /* else {
            _obj = {
                id: "0102",
                text: "您的用户信息未完善，请先完善",
                tit: "用户信息",
                name: ""
            };
            infoCheckResult.push(_obj);
        } */
        //infoCheckResult.push(_obj);
    }
    /* //ocr证件是否上传
    if (info.needOcrUpload === "1") {
        _obj = {
            id: "0108",
            text: "您的证件资料还未上传，请先上传有效证件",
            tit: "证件未上传",
            name: ""
        };
        infoCheckResult.push(_obj);
    } */
    // CRS
    if (info.needfillcrs === "1") {
        _obj = {
            id: "0104",
            text: "您还未完善CRS信息，请先完善",
            tit: "CRS信息",
            name: ""
        };
        infoCheckResult.push(_obj);
    }
    //完善客户信息提示
    if (info.needfillcustinfo === "1"){
        _obj = {
            id: "0102",
            text: "您还未完善账户信息，请先完善",
            tit: "用户信息",
            name: ""
        };
        infoCheckResult.push(_obj);
    }
    // 准入
    if (info.isneedidentify === "1") {
        _obj = {
            id: "0105",
            text: "您还未做投资者准入，请先完善",
            tit: "投资者准入",
            name: ""
        };
        infoCheckResult.push(_obj);
    }
    // 适当性补录
    if (info.needfillappro === "1") {
        _obj = {
            id: "0103",
            text: "您还未完善适当性信息，请先完善",
            tit: "适当性信息",
            name: ""
        };
        infoCheckResult.push(_obj);
    }
    // 只检查一级菜单
    if (cate) {
        return infoCheckResult;
    }
    // 持有银行卡
    if (info.activecardnum === "0") {
        _obj = {
            id: "0202",
            text: "您还未持有可用银行卡，请先完善",
            tit: "银行卡",
            name: ""
        };
        infoCheckResult.push(_obj);
    }
    return infoCheckResult;
};

/* 判断用户需完善信息
 @param [Array] check 需要完善的用户信息列表
 @param [Object] router 路由对象
 @returns [String] 返回判断信息
 */
const initCheck = (check, next, cate) => {
    let _html = "";
    check.forEach(item => {
        _html +=
            "<div class=\"user-info-check\"><i class=\"fa fa-exclamation-triangle\"></i>" +
            item.text +
            "</div>";
    });
    Vue.prototype
        .$alert(_html, "信息完善", {
            dangerouslyUseHTMLString: true,
            confirmButtonText: "立即前往处理",
            customClass: "info-check",
            beforeClose: (action, instance, done) => {
                if (action === "confirm") {
                    next({
                        name: "checkacct",
                        query: {
                            cate: cate
                        }
                    });
                    done();
                } else {
                    Vue.prototype.$message({
                        type: "info",
                        message: "放弃完善用户信息"
                    });
                    done();
                }
            }
        })
        .then(() => {
            return false;
        })
        .catch(() => {
            return false;
        });
};

const initCheck2 = (check, next, cate) => {
    let dialogInfo = "您的证件资料还未上传，请先上传有效证件";
    if (cache.getUser().certexpired === "1") {
        if (cache.getUser().certificatetype !== "0") {
            dialogInfo = "您的证件有效期已经过期，请重新上传证件照并修改证件有效期";
        }else {
            dialogInfo = "您的证件有效期已经过期，请重新上传有效证件以更新证件有效期";
        }
    }
    let _html = "<div class=\"user-info-check\"><i class=\"fa fa-exclamation-triangle\"></i>" + dialogInfo + "</div>";
    Vue.prototype
        .$alert(_html, "信息完善", {
            dangerouslyUseHTMLString: true,
            confirmButtonText: "立即前往处理",
            customClass: "info-check",
            beforeClose: (action, instance, done) => {
                if (action === "confirm") {
                    next({
                        name: "ocrinfoupd",
                        query: {
                            certificatetype: cache.getUser().certificatetype
                        }
                    });
                    done();
                } else {
                    Vue.prototype.$message({
                        type: "info",
                        message: "放弃完善用户信息"
                    });
                    done();
                }
            }
        })
        .then(() => {
            return false;
        })
        .catch(() => {
            return false;
        });
};
// 转换身份证位数提示及操作。
const initCheck3 = (next) => {
    let pwdHtml = cache.getPwdCheck("B1") ? "<input id='dialog-pwd' style='display: block;width:200px;height:22px;line-height:22px;' type='password' placeholder='请输入交易密码' maxlength='16'/>" : "";
    let _html = "<div class=\"user-info-check\"><i class=\"fa fa-exclamation-triangle\"></i>查询到您的身份证号码为15位，业务操作需要进行身份证升位，否则将无法登陆首页。<br />需要将身份证升位到"
    + cache.getUser().newcertno
    + "吗？<br />"
    + pwdHtml
    + "</div>";
    Vue.prototype
        .$alert(_html, "身份证升位", {
            dangerouslyUseHTMLString: true,
            confirmButtonText: "立即升位",
            customClass: "info-check",
            beforeClose: (action, instance, done) => {
                if (action === "confirm") {
                    let datas = cache.getPwdCheck("B1") ? {tradepwd: Vue.prototype.$util.enc(document.getElementById("dialog-pwd").value)} : {};
                    req({
                        method: "PUT",
                        url: "acct/modify/certno",
                        timeout: 20000,
                        data: datas
                    }).then(res => {
                        if (res.code === "0000000") {
                            const info = cache.getUser();
                            info.modifycertno = "0";
                            info.certificateno = cache.getUser().newcertno;
                            store.dispatch("setInfo", info).then(() => {
                                Vue.prototype.$message({
                                    type: "success",
                                    message: "身份证升位成功！"
                                });
                            });
                        } else {
                            this.$message.error(res.msg);
                            Vue.prototype.$util.request("common/logout", {}, false, false).then(res => {
                                if (res.data) {
                                    store.dispatch("logout", res.data[0]).then(() => {
                                        next({
                                            name: "login"
                                        });
                                    });
                                }
                            });
                        }
                    }).catch(() => {
                        Vue.prototype.$util.request("common/logout", {}, false, false).then(res => {
                            if (res.data) {
                                store.dispatch("logout", res.data[0]).then(() => {
                                    next({
                                        name: "login"
                                    });
                                });
                            }
                        });
                    });
                    done();
                } else {
                    Vue.prototype.$message({
                        type: "info",
                        message: "已放弃升位身份证号码，退回登录页"
                    });
                    Vue.prototype.$util.request("common/logout", {}, false, false).then(res => {
                        if (res.data) {
                            store.dispatch("logout", res.data[0]).then(() => {
                                next({
                                    name: "login"
                                });
                            });
                        }
                    });
                    done();
                }
            }
        })
        .then(() => {
            return false;
        })
        .catch(() => {
            return false;
        });
};
/* 判断是否含有三个或三个以上的连续字符
    @param {String} inputpass 判读连续字符值
    @param {String} n 连续字符个数,默认2,必须大于1
    @return [Boolean] 校验结果，true or false
    */
const checkSeries = (inputpass, n) => {
    n = Number(n) || 2;
    if (inputpass.length < (n + 1)) return true;
    for (let i = 0; i < inputpass.length - n; i++) {
        let _charPwd = inputpass.charCodeAt(i);
        let _index = 0;
        let _indexCom = 0;
        for (let j = 1; j < (n + 1); j++) {
            const _x = inputpass.charCodeAt(i + j);
            if (isNaN(_x)) {
                return true;
            }
            if (_x - j === _charPwd || _x === _charPwd) {
                if(_x - j === _charPwd){
                    _index++;
                }else{
                    _index = 0;
                }
                if(_x === _charPwd){
                    _indexCom++;
                }else{
                    _indexCom = 0;
                }
            }else{
                break;
            }
        }
        if (_index >= n) {
            return true;
        }
    }
    return false;
};
/* 判断密码是否符合规范
 @param [String] value 需要校验密码
 @param [Boolean] flag 是否校验是校验交易密码
 @return [String/Boolean] 校验结果信息，false符合密码规范，String校验不通过信息
 */
const checkSameChar = (value, flag) => {
    if (value === "") {
        return "请输入密码";
    }
    if (value.length !== value.replace(/\s*/g, "").length) {
        return "不能含有空格";
    }
    if (flag) {
        if (!/[0-9]{6,16}$/.test(value)) {
            return "密码必须为6-16位纯数字";
        }
        if (flag === "1" && !/[0-9]{6}$/.test(value)) {
            return "密码必须为6位纯数字";
        }
        if (value.search(/(\w)\1{2}/) !== -1) {
            return "不能含有三个连续相同的字符";
        }
        if (checkSeries(value, 2)) {
            return "不能含有三个或三个以上的连续字符";
        }
    } else {
        // 登录密码规则从接口获取
        const _p = cache.getCompanyInfo();
        // 密码包含数字
        if (_p.pwdneednumber === "1" && !/[0-9]/.test(value)) {
            return "密码必须包含数字";
        }
        if (_p.pwdneedword === "1" && !/[a-zA-Z]/.test(value)) {
            return "密码必须包含字母";
        }
        if (_p.pwdneedupperletter === "1" && !(/[A-Z]/.test(value) && /[a-z]/.test(value))) {
            return "密码必须包含大小写字母";
        }
        if (!/[a-zA-Z0-9]{6,16}/.test(value)) {
            return "密码必须为6-16位字母或数字";
        }
        if (_p.pwdnotcontinu === "1" && checkSeries(value, 2)) {
            return "密码不能有2个以上连续的数字或字母";
        }
    }
    return false;
};
/* 判断字符串字节长度
 @param [String] value 字符串
 @return [String/Boolean] 字符串字节长度
 */
const getBLen = str => {
    if (str == null) return 0;
    if (typeof str !== "string") {
        str += "";
    }
    return str.replace(/[^\u4E00-\u9FA5\uf900-\ufa2d]/g, "ab").length;
};
/* 判断验证码是否符合规范
 @param [String] value 需要校验验证码
 @return [String/Boolean] 校验结果信息，false符合验证码规范，String验证码校验不通过信息
 */
const checkVerifyCode = value => {
    if (value === "") {
        return "请输入验证码";
    }
    const b = "4";
    const c = "4";
    let a = b !== c ? b + "-" + c : b;
    let e = "数字或字母";
    if (value.length < b || value.length > c) {
        return "验证码应为" + a + "位" + e;
    }
    const pattern = /^[0-9a-zA-Z]*$/g;
    if (!pattern.test(value)) {
        return "验证码应为" + a + "位" + e;
    }
};
/* 校验身份证号码
 @inParam [String] value 获取到的校验项值
 @return [Boolean] 校验结果 true为身份证号码
 */
const checkIdCard = code => {
    const reg =
        /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
    if (reg.test(code)) {
        return true;
    }
    return false;
};
export default {
    /* 获取用户状态
  @inParam [String] 路由path
  @return [Array] 需要校验的数据
  */
    checkAcct(to, from, next, params) {
        const info = cache.getUser();
        const _cate = params.checkCate ? params.checkCate.toString() : "";
        // 检查用户是否开通网上交易
        if (
            info.usertype === "2" ||
            !info.tradingmethod ||
            info.tradingmethod.indexOf("2") === -1
        ) {
            if (_cate.indexOf("1") > -1) {
                // 代销用户能直接查看用户信息
                if (!(to.path === "/info/modifyinfo" && info.usertype === "2")) {
                    // 未绑定交易账户增卡直接跳转到绑定账户
                    if (to.path === "/bank/addbank") {
                        next({
                            name: "bindnewacct"
                        });
                    } else {
                        let _x = "此类操作";
                        if (_cate.indexOf("3") > -1) {
                            _x = "购买/定投基金等交易功能";
                        }
                        Vue.prototype
                            .$confirm(
                                "您的账户尚未认证，暂时无法进行" + _x + "，是否立即前往账户认证",
                                "交易手段信息提示", {
                                    confirmButtonText: "前往",
                                    cancelButtonText: "返回",
                                    type: "warning",
                                    customClass: "info-check"
                                }
                            ).then(() => {
                                next({
                                    name: "bindacctway"
                                });
                            }).catch(() => {});
                    }
                    return false;
                } else {
                    return true;
                }
            }
        }
        const _y = sessionStorage.getItem("alreadyread") || "";
        cache.initCityCountyList();
        // 检查用户信息是否完善
        if (_cate.indexOf("2") > -1 || _cate.indexOf("3") > -1) {
            const _f = !(_cate.indexOf("3") > -1);
            const _check = userCheck(info, _f, to.path);
            // 判断客户是否为15位身份证号码，提示并转换身份证位数，否则退出。
            if (info.usertype !== "2" && info.modifycertno === "1") {
                if (window.navigator.userAgent.indexOf("MSIE 9.0") >= 1) {
                    setTimeout(function(){initCheck3(next);}, 1500);
                } else {
                    initCheck3(next);
                }
                const _f = !(_cate.indexOf("3") > -1);
                if (!_f) {
                    return false;
                }
            } else if(_y.indexOf("5") === -1 && info.unactivecardnum && Number(info.unactivecardnum > 0)){
                sessionStorage.setItem("alreadyread",(_y + ",5"));
                Vue.prototype.$confirm(
                    "您还有" + info.unactivecardnum + "张银行卡未激活，请前往激活。",
                    "银行卡信息提示", {
                        confirmButtonText: "前往",
                        cancelButtonText: "返回",
                        type: "warning",
                        customClass: "info-check"
                    }
                ).then(() => {
                    next({
                        name: "bank"
                    });
                }).catch(() => {});
                /* if(!_f || _check.length > 0){
                    return false;
                } */
                if(!_f){
                    return false;
                }
            }else if (info.needOcrUpload === "1" && (to.path !== "/fund/sellfund" && to.path !== "/fund/ordersell" && to.path !== "/currencyfund/currencyredemption"
                && to.path !== "/fund" && to.path !== "/cfund" && to.path !== "/fund/buyfund" && to.path !== "/fund/changefund" && to.path !== "/gfund/generalbuy"
            )) {
                /* if(_y.indexOf("3") === -1 || !_f){
                    const _n = _y.indexOf("3") === -1 ? (_y + ",3") : _y;
                    sessionStorage.setItem("alreadyread",_n);
                    initCheck2(_check, next, _f);
                } */
                if (window.navigator.userAgent.indexOf("MSIE 9.0") >= 1) {
                    setTimeout(function(){initCheck2(_check, next, _f);}, 1500);
                } else {
                    initCheck2(_check, next, _f);
                }
                if (!_f) {
                    return false;
                }
            } else if (info.needOcrUpload === "2" && (!sessionStorage.getItem("ocropen") || JSON.parse(sessionStorage.getItem("_a")).token !== sessionStorage.getItem("ocropen")) && (to.path !== "/fund/sellfund" && to.path !== "/fund/ordersell" && to.path !== "/currencyfund/currencyredemption"

            )) {
                /* 针对ocr开关登录后提示和只提示一次的情况 */
                sessionStorage.setItem("ocropen", JSON.parse(sessionStorage.getItem("_a")).token);
                /* if(_y.indexOf("3") === -1 || !_f){
                    sessionStorage.setItem("alreadyread",(_y.indexOf("3") === -1 ? (_y + ",3") : _y));
                    initCheck2(_check, next, _f);
                } */
                if (window.navigator.userAgent.indexOf("MSIE 9.0") >= 1) {
                    setTimeout(function(){initCheck2(_check, next, _f);}, 1500);
                } else {
                    initCheck2(_check, next, _f);
                }
                if (!_f) {
                    return false;
                }
            } else if (_check.length > 0 && to.path.indexOf("checkacct") === -1) {
                if(_y.indexOf("4") === -1 || !_f){
                    sessionStorage.setItem("alreadyread",(_y.indexOf("4") === -1 ? (_y + ",4") : _y));
                    if (window.navigator.userAgent.indexOf("MSIE 9.0") >= 1) {
                        setTimeout(function(){initCheck(_check, next, _f);}, 1500);
                    } else {
                        initCheck(_check, next, _f);
                    }
                }
                if (!_f) {
                    return false;
                }
            }
        }
        return true;
    },
    /* 用户未处理信息获取
 @inParam [Object] info 用户信息
 @inParam [String] cate 是否获取额外用户未完善信息
 @return [Array] 处理后的数据
 */
    acctStatus(info, cate) {
        return userCheck(info, cate);
    },
    /* 获取专业投资者信息
 @inParam [callback] cb 是否获取额外用户未完善信息
 */
    getProfession(cb){
        this.request("acct/info/profession").then(res=>{
            if(res.data){
                if(cb){
                    cb.call(this,res.data[0] || "");
                }
            }
        });
    },
    /* 金额过滤处理
  @inParam [String] val 金额原数据
  @return [Array] 金额处理后数据
  */
    checkAmount(val) {
        const regStr = [
            ["^0(\\d+)$", "$1"], // 禁止录入整数部分两位以上，但首位为0
            ["[^\\d\\.]+$", ""], // 禁止录入任何非数字和点
            ["\\.(\\d?)\\.+", ".$1"], // 禁止录入两个以上的点
            ["^(\\d+\\.\\d{2}).+", "$1"] // 禁止录入小数点后两位以上
        ];
        for (let i = 0; i < regStr.length; i++) {
            const reg = new RegExp(regStr[i][0]);
            val = val.replace(reg, regStr[i][1]);
        }
        return val;
    },
    /* 校验表单查询密码信息
	@inParam [Object] rule 校验规则信息
	@inParam [String] value 获取到的校验项值
	@inParam [Object] callback 校验后回调函数
	*/
    validateQryPwd(rule, value, callback) {
        const msg = checkSameChar(value, "1");
        if (msg) {
            callback(new Error(msg));
        } else {
            callback();
        }
    },
    /* 校验表单登录密码信息
	@inParam [Object] rule 校验规则信息
	@inParam [String] value 获取到的校验项值
	@inParam [Object] callback 校验后回调函数
	*/
    validatePwd(rule, value, callback) {
        const msg = checkSameChar(value);
        if (msg) {
            callback(new Error(msg));
        } else {
            callback();
        }
    },
    /* 校验表单交易密码信息
	@inParam [Object] rule 校验规则信息
	@inParam [String] value 获取到的校验项值
	@inParam [Object] callback 校验后回调函数
	*/
    validateTPwd(rule, value, callback) {
        const msg = checkSameChar(value, true);
        if (msg) {
            callback(new Error(msg));
        } else {
            callback();
        }
    },
    /* 校验表单图片验证码信息
	@inParam [Object] rule 校验规则信息
	@inParam [String] value 获取到的校验项值
	@inParam [Object] callback 校验后回调函数
	*/
    validateImgVerifyCode(rule, value, callback) {
        const msg = checkVerifyCode(value);
        if (msg) {
            callback(new Error(msg));
        } else {
            callback();
        }
    },
    /* 校验表单验证码信息
	@inParam [Object] rule 校验规则信息
	@inParam [String] value 获取到的校验项值
	@inParam [Object] callback 校验后回调函数
	*/
    validateVerifyCode(rule, value, callback) {
        if (value === "") {
            callback(new Error("请输入验证码"));
        } else {
            const reg = /^[0-9a-zA-Z]{4,6}$/;
            if (reg.test(value)) {
                callback();
            } else {
                callback(new Error("验证码应为4-6位数字或字母"));
            }
        }
    },
    /* 校验输入金额小数位数
	@inParam [Object] rule 校验规则信息
	@inParam [String] value 获取到的校验项值
	@inParam [Object] callback 校验后回调函数
	*/
    validateDecimal(rule, value, callback) {
        const reg = /^\d+(\.\d{1,2})?$/;
        if (value !== "" && !reg.test(value)) {
            callback(new Error("不能输入超过两位小数"));
        } else {
            if ( value !== "" ) {
                callback();
            } else {
                callback(new Error("请输入" + rule.mes));
            }
        }
    },
    /* 校验输入金额区间
	@inParam [Object] _this VUE实例对象
	@inParam [Object] rule 校验规则信息
	@inParam [String] value 获取到的校验项值
	@inParam [Object] callback 校验后回调函数
	*/
    validateAmountLimit(_this, rule, value, callback) {
        if (
            Number(value) >= Number(_this.limit.min) &&
            Number(value) <= Number(_this.limit.max)
        ) {
            this.validateDecimal(rule, value, callback);
        } else {
            callback(
                new Error(Number(_this.limit.min) < Number(_this.limit.max) ? (_this.limit.text + _this.limit.min + "-" + _this.limit.max) : "输入范围不符合要求")
            );
        }
    },
    /* 校验只能输入正整数
	@inParam [Object] _this VUE实例对象
	@inParam [Object] rule 校验规则信息
	@inParam [String] value 获取到的校验项值
	@inParam [Object] callback 校验后回调函数
	*/
    validateInteger(rule, value, callback){
        const reg = /^[1-9]\d*$/;
        if (value !== "" && !reg.test(value)) {
            callback(new Error(rule.mes + "只能输入整数"));
        } else {
            if ( value !== "" ) {
                callback();
            } else {
                callback(new Error("请输入" + rule.mes));
            }
        }
    },
    /* 校验单个复选框是否选中
	@inParam [Object] rule 校验规则信息
	@inParam [String] value 获取到的校验项值
	@inParam [Object] callback 校验后回调函数
	@inParam [String] msg 提示信息
	*/
    validateProtocol(rule, value, callback, msg) {
        if (!value) {
            callback(new Error(msg));
        } else {
            callback();
        }
    },
    /* 校验证件号码
   @inParam [Object] rule 校验规则信息
   @inParam [String] value 获取到的校验项值
   @inParam [Object] callback 校验后回调函数
   @inParam [String] certType 证件类型
   */
    validateCertNo(rule, value, callback, certType) {
        if (certType === "0") {
            const _x = checkIdCard(value);
            if (!_x) {
                callback(new Error("身份证号码不正确"));
            } else {
                callback();
            }
        } else {
            const reg = /^[a-zA-Z0-9\u4e00-\u9fa5（）()-]{4,20}$/g;
            if (reg.test(value) && this.widthCheck(value,30)) {
                callback();
            } else {
                callback(new Error("证件号为4-20个字节的数字、字母或中文组合"));
            }
        }
    },
    widthCheck(value, len) {
        let temp = 0;
        let i = 0;
        let charCode = "";
        for (i = 0; i < value.length; i++) {
            charCode = value.charCodeAt(i);
            if (charCode <= 0x007f) {
                temp += 1;
            } else if (charCode <= 0x07ff) {
                temp += 2;
            } else if (charCode <= 0xffff) {
                temp += 3;
            } else {
                temp += 4;
            }
            if (temp > len) {
                return false;
            }
        }
        return true;
    },
    /* 校验银行卡号码
	@inParam [Object] rule 校验规则信息
	@inParam [String] value 获取到的校验项值
	@inParam [Object] callback 校验后回调函数
	*/
    validateBankNum(rule, value, callback) {
        const reg = /^[0-9]{8,20}$/g;
        if (reg.test(value)) {
            callback();
        } else {
            callback(new Error("银行卡号只能为8-20位数字"));
        }
    },
    /* 校验姓名
	@inParam [Object] rule 校验规则信息
	@inParam [String] value 获取到的校验项值
	@inParam [Object] callback 校验后回调函数
	*/
    validateName(rule, value, callback) {
        const reg = /^[\u4E00-\u9FA5\uf900-\ufa2d·]{2,40}$/;
        const regLetter = /^[a-zA-Z\s]{2,60}$/;
        if (value === "") {
            callback(new Error("姓名不能为空"));
        }
        if ((reg.test(value) && getBLen(value) < 80) || regLetter.test(value)) {
            callback();
        } else {
            callback(new Error("姓名长度为2-40位中文或2-60位字母"));
        }
    },
    /* 校验输入内容是否仅为字母、中文及分割点
   @inParam [Object] rule 校验规则信息
   @inParam [String] value 获取到的校验项值
   @inParam [Object] callback 校验后回调函数
   @inParam [String] mes 校验表单信息
   */
    validateGeneral(rule, value, callback, mes) {
        if (value === "") {
            callback(new Error(mes + "输入不能为空"));
        }
        const reg = /^[a-zA-Z\u4e00-\u9fa5·]{2,20}$/g;
        if (!reg.test(value)) {
            callback(new Error(mes + "输入数据不规范"));
        } else {
            callback();
        }
    },
    /* 校验姓名
	@inParam [Object] rule 校验规则信息
	@inParam [String] value 获取到的校验项值
	@inParam [Object] callback 校验后回调函数
	*/
    validateBankName(rule, value, callback) {
        const reg = /^[\u4E00-\u9FA5\uf900-\ufa2d·sa-zA-Z\d]{2,40}$/;
        if (!reg.test(value)) {
            callback(new Error("开户行名称长度为4-40位"));
        }
        callback();
    },
    /* 校验日期
	@inParam [Object] rule 校验规则信息
	@inParam [String] value 获取到的校验项值
	@inParam [Object] callback 校验后回调函数
	*/
    validateDate(rule, value, callback) {
        value = value.replace(/(^\s*)|(\s*$)/g, "");
        if (value) {
            callback();
        } else {
            callback(new Error("请输入日期"));
        }
    },
    /* 校验是否为中英文字母及数字
	@inParam [Object] rule 校验规则信息
	@inParam [String] value 获取到的校验项值
	@inParam [Object] callback 校验后回调函数
	*/
    validateCCharacter(rule, value, callback) {
        const reg = /^[a-zA-Z0-9\u4e00-\u9fa5]+$/;
        if (!reg.test(value)) {
            callback(new Error("只能输入中英文字母及数字"));
        } else {
            callback();
        }
    },
    /* 获取验证码图片地址
   @inParam [Object] 组装url参数
   @return [String] 组装后的url
   */
    imgUrl(params) {
        params = Object.assign({
            width: "112",
            height: "38",
            count: 4,
            x: Math.random()
        },
        params || {}
        );
        return this.src("/common/authimg", params);
    },
    /* 查询页面协议信息
	@inParam [String] type 协议类型
	@return [Object] Promise
	@Promise-then [Array] 查询到的协议数据结果集
	*/
    getProtocol(type) {
        if (!type) return;
        return new Promise((resolve, reject) => {
            req({
                method: "GET",
                url: "/common/protocol",
                params: {
                    type: type
                }
            }).then(res => {
                const returnData = res.record[0];
                resolve(returnData);
            }).catch(err => reject(err));
        });
    },
    /* 查询风险页面协议信息
	@inParam [String] type 协议类型
	@return [Object] Promise
	@Promise-then [Array] 查询到的协议数据结果集
	*/
    getRiskProtocol(type) {
        if (!type) return;
        return new Promise((resolve, reject) => {
            req({
                method: "GET",
                url: "common/sdx",
                params: {
                    type: type
                }
            }).then(res => {
                if (res.code === "0000000") {
                    const returnData = res.record[0][0] ? res.record[0][0].content : "";
                    resolve(returnData);
                }
            }).catch(err => reject(err));
        });
    },
    /* 数字千分位加逗号
	@inParam [String] str 需要格式化的值
	@inParam [Number] digit 需要保留小数点多少位，不足自动以0增添
	@return [Boolean] 格式化后的结果
	*/
    fmtNum(str, digit) {
        if (str === undefined || isNaN(Number(str)) || str === "") {
            return "--";
        }
        str = str.toString().replace(/\$|\\,/g, "");
        if (arguments.length === 1) {
            digit = 2;
        }
        let _x = false;
        if (Number(str) === 0) {
            str = 1;
            _x = true;
        }
        if (Number(str) < 1 && Number(str) > -1) {
            str = str > 0 ? Number(str) + 1 : str - 1;
            _x = true;
        }
        var powStr = Math.round(str * Math.pow(10, digit)); // 把指定的小数位先转换成整数.多余的小数位舍去
        let cents = powStr.toString();
        cents = cents.substr(cents.length - digit, digit);
        // 对整数部分进行千分位格式化.
        //str = parseInt(str / Math.pow(10, digit)).toLocaleString();
        //修复toLocaleString在某些安卓浏览器输出空，导致数字失去整数部分。
        str = this.toThousands(parseInt(str));
        // 处理IE11以下出现小数点数字的问题
        const _p = str.indexOf(".");
        if (_p > -1) {
            str = str.substr(0, _p);
        }
        // 对小于精确位数的负浮点数进行处理
        const _r = str + "." + cents;
        if (_x) str = (str < 0 && Number(_r) !== -1 ? "-" : "") + "0";
        return str + "." + cents;
    },
    toThousands(num) {
        var result = "", counter = 0;
        num = (num || 0).toString();
        for (var i = num.length - 1; i >= 0; i--) {
            counter++;
            result = num.charAt(i) + result;
            if (!(counter % 3) && i != 0 && /^[0-9]*$/.test(num[i - 1])) {
                result = "," + result;
            }
        }
        return result;
    },
    /* 生成图片src的url（追加/api/v1前缀, 添加公参）
	@inParam [String] url
	@inParam [Object] 参数对象。注意url参数必须放在这里，不允许以查询串的形式直接跟在第一个参数url中
	@return [String] 加工后的url
	*/
    src(url, params, flag) {
        params = Object.assign(params || {}, {
            token: cache.getSessionToken(),
            g_systemtype: conf.systemtype
        });
        let queryStr = "?";
        for (let prop in params) {
            queryStr += prop + "=" + encodeURIComponent(params[prop]) + "&";
        }
        queryStr = queryStr.substring(0, queryStr.length - 1);
        return (!flag ? conf.api.baseUrl : "") + url + queryStr;
    },
    /* 打开一个新页面，用于跳转银行卡页面鉴权
	@inParam [String] bankUrl 银行接口返回银行鉴权地址
	*/
    newWinOpen(bankUrl) {
        const getRootPath = function() {
            return (
                window.location.protocol + "//" + window.location.host + conf.api.bankUrl
            );
        };
        let openUrl = getRootPath() + "/img/bank.html?bankUrl=" + bankUrl;
        window.open(openUrl);
    },

    newWinOpenSign(signUrl) {
        const getRootPath = function() {
            return (
                window.location.protocol + "//" + window.location.host + conf.api.bankUrl
            );
        };
        let openUrl = getRootPath() + "/img/sign.html?signUrl=" + signUrl;
        window.open(openUrl);
    },

    // 针对
    newWinOpenSignPage(signUrl) {
        const getRootPath = function() {
            return (
                window.location.protocol + "//" + window.location.host + conf.api.bankUrl
            );
        };
        let openUrl = getRootPath() + "/img/signpage.html?signUrl=" + signUrl;
        window.open(openUrl);
    },
    /* 页面鉴权获取鉴权信息
	@inParam [Object] param 配置信息
	@inParam [Object] fn 校验后回调函数
	*/
    confirmBankAuth(_this, param, url, fn) {
        param = param || {};
        const h = _this.$createElement;
        let actionName = param.action || "认证";
        if (url === "trade/buy/payresult") {
            actionName = "支付";
        }
        _this.$msgbox({
            title: param.title || "银行认证页面",
            message: h("p", null, "请在所弹出的银行页面完成认证操作!"),
            showCancelButton: true,
            confirmButtonText: actionName + "完成",
            cancelButtonText: actionName + "出现问题",
            closeOnClickModal: false,
            roundButton: true
        }).then(action => {
            if (action === "confirm") {
                let _x = {
                    method: "GET",
                    url: url,
                    params: {}
                };
                req(_x).then(res => {
                    if (res.code === "0000000") {
                        if (
                            res.record[0][0].status === "1" ||
                            res.record[0][0].bankbizsuccess === "1"
                        ) {
                            _this.$message({
                                type: "success",
                                message: actionName + "完成,3秒后页面跳转",
                                onClose: function() {
                                    fn();
                                }
                            });
                        } else {
                            _this.$message.error("获取鉴权信息失败，请重试");
                        }
                    } else {
                        _this.$message.error(res.msg);
                    }
                }).catch(() => {});
            } else {
                return false;
            }

        }).catch(() => {
            return false;
        });
    },
    /* 格式化整型日期,仅检查位数和字符有效性，如果无效返回
	@inParam [String] date 可以是Date、int、string类型
	@inParam [String] sSplit 分隔符,默认'-','CN'表示用年月日分隔
	@return [String] 组装后的日期
	*/
    fmtDate(date, sSplit) {
        if (!date) {
            return "--";
        }
        let sDate, sY, sM, sD;
        if (isNaN(date) && !isNaN(Date.parse(date))) {
            sY = date.getFullYear();
            sM = date.getMonth() + 1 + "";
            if (sM.length === 1) {
                sM = "0" + sM;
            }
            sD = date.getDate() + "";
            if (sD.length === 1) {
                sD = "0" + sD;
            }
        } else {
            sDate = date.toString();
            if (/^\d{8}$/.test(sDate)) {
                sY = sDate.substring(0, 4);
                sM = sDate.substring(4, 6);
                sD = sDate.substring(6, 8);
            } else {
                return "--";
            }
        }

        if (sSplit === "CN") {
            sDate = sY + "年" + sM + "月" + sD + "日";
        } else {
            if (sSplit === undefined || sSplit == null) {
                sSplit = "-";
            }
            sDate = sY + sSplit + sM + sSplit + sD;
        }
        return sDate;
    },
    /* 表单数据校验
	@inParam [Object] _this Vue实例对象
	@inParam [String] formName 校验表单对象名
	@return [String] 函数返回
	*/
    mobileCheck(_this, formName) {
        let mes = "";
        // 处理银行卡找回密码表单数据校验
        if (
            _this.checkBank ||
            (!_this.hasTranAcct && _this.hasTranAcct !== undefined)
        ) {
            for (const key in _this.pwdForm) {
                if (key !== "mobile" && key !== "verifyCode" && key !== "type") {
                    _this.$refs[formName].validateField(key, function(str) {
                        if (str) {
                            mes = str;
                            return false;
                        }
                    });
                }
            }
        }
        if (mes !== "") {
            return false;
        }
        _this.$refs[formName].validateField("mobile", function(str) {
            if (str === "") {
                if (
                    _this.checkBank ||
                    (!_this.hasTranAcct && _this.hasTranAcct !== undefined)
                ) {
                    _this.sendBank();
                } else {
                    _this.dialogVisible = true;
                }
            } else {
                return false;
            }
        });
    },
    /* 按钮读秒倒计时
	@inParam [Object] _this Vue实例对象
	@inParam [Object] fn 回调函数
	@inParam [String] text 回调函数
	*/
    btnDisabled(_this, fn, text) {
        const setTime = setInterval(function() {
            _this.time--;
            _this.btnMsg = "等待" + _this.time + "秒";
            if (_this.time === 0 || _this.time === undefined) {
                clearInterval(setTime);
                _this.btnMsg = text || "获取验证码";
                if (fn) {
                    fn.call(this, _this);
                }
            }
        }, 1000);
    },
    /* 发送短信验证码
	@inParam [Object] _this Vue实例对象
	@inParam [String] val 图片验证码值
	@inParam [String] formName 校验表单对象名
	@inParam [String] url 访问链接
	*/
    sendSms(_this, val, formName, url) {
        _this.dialogVisible = false;
        let data = {
            mobile: _this[formName].mobile,
            verifycode: val
        };
        req({ method: "POST", url: url, data: data }).then(res => {
            if (res.code === "0000000") {
                /* 倒计时 */
                _this.time = res.record[0][0].sendperiod;
                _this.locked = true;
                _this.$util.btnDisabled(_this);
            } else {
                _this.$message({
                    type: "warning",
                    message: res.msg
                });
            }
        }).catch(() => {});
    },
    /* 请求封装
	@inParam [String] url 请求地址
	@inParam [Object] data 请求入参
	@inParam [Boolean] way get或post请求，默认get
	@inParam [Boolean] loader 是否显示局部加载图标
	@Promise-then [Array] 查询到的数据结果集
	*/
    request(url, data, way, loader, blob) {
        const method = !way || way === "GET" ? "GET" : way;
        // 处理特殊情况两个相同请求需要同时发送，在url后面加&
        const repeat = url.indexOf("&") > -1;
        url = url.replace(/&/, "");
        data = data || {};
        // 加载区域配置
        // loader: {
        //   target: '.login-panel'
        // }
        let param = {
            method: method,
            url: url,
            loader: loader,
            repeat: repeat
        };
        // 针对文件下载设置文件流格式
        if (blob) param.responseType = "arraybuffer";

        if (method === "GET" || method === "DELETE") {
            param.params = data;
        } else {
            param.data = data;
        }
        return new Promise((resolve, reject) => {
            req(param)
                .then(res => {
                    let returnData = {
                        msg: res.msg
                    };
                    if (res.code === "0000000") {
                        const _x = res.record.length > 1 ? res.record : res.record[0];
                        if (res.alllength) {
                            returnData.alllength = res.alllength;
                        }
                        returnData.data = _x;
                    }
                    resolve(returnData);
                })
                .catch(() => {});
        });
    },
    /* 加载图片
	@inParam [String] id 图片id
	@return [String] 组合图片地址
	*/
    getImg(id) {
        try {
            return require("../../public/bankImg/" + id + ".png");
        } catch (e) {
            return "../../public/bankImg/" + id + ".png";
        }
    },
    /* 获取下拉银行卡列表信息
	@inParam [String] url 获取银行卡链接
	@inParam [Function] cb 回调函数
	*/
    getBank(url, cb) {
        this.request(url).then(res => {
            let _obj = {
                bank: [],
                other: {}
            };
            if (res.data) {
                _obj.bank = this.getBankArr(res.data[0]);
                // 处理其他结果集信息
                if (res.data[1]) {
                    _obj.other = res.data[1][0];
                }
            }
            // 返回银行卡数据
            if (cb) {
                cb.call(this, _obj);
            }
        });
    },
    /* 获取银行卡列表信息并特殊处理用于列表展示
	@inParam [String] url 获取银行卡信息链接
	@inParam [Function] cb 回调函数
	*/
    getBankInfo(url,params, cb) {
        this.request(url,params).then(res => {
            if (res.data) {
                const _arr = res.data;
                let bank = [];
                const x = {};
                // 合并银行卡
                for (let i of _arr) {
                    const _x = i.channelname.indexOf("-");
                    if (_x > -1) {
                        i.channelname = i.channelname.substring(_x + 1);
                    }
                    if (i.channelid === conf.const.TTY_CHANLEID) {
                        i.bankid = "TTY";
                    }
                    if (!x[i.bankid]) {
                        i.child = [];
                        i.child.push(i);
                        bank.push(i);
                        x[i.bankid] = true;
                    } else {
                        for (let j of bank) {
                            if (j.bankid === i.bankid) {
                                j.child.push(i);
                            }
                        }
                    }
                }
                // 返回银行卡数据
                if (cb) {
                    cb.call(this, bank);
                }
            }
        });
    },
    /* 组装下拉银行卡列表信息
	 @inParam [Array] bankArr 需要组装的银行卡信息
	 @return [String] 组装后的银行卡信息
	*/
    getBankArr(bankArr,hk) {
        const _y = bankArr;
        hk = hk || "";
        // 初始化银行卡信息
        let bankLists = [{
            label: "",
            options: [{
                value: "",
                bankAdd: "添加银行卡",
                bankCate: "你还没有可用银行卡",
                label: ""
            }]
        }];
        if (_y && _y.length > 0) {
            let _x = {};
            for (let i in _y) {
                if(_y[i].hkcardflag && hk && _y[i].hkcardflag !== "1"){
                    continue;
                }
                if(_y[i].zxcardflag && !hk && _y[i].zxcardflag !== "1"){
                    continue;
                }
                let _z = {};
                _z.value = _y[i].channelid;
                _z.bankid = _y[i].bankid;
                _z.biztype = _y[i].biztype;

                _z.moneyaccount = _y[i].moneyaccount;
                _z.paytype = _y[i].paytype;
                // 处理天天盈渠道
                if (_y[i].channelid === conf.const.TTY_CHANLEID) {
                    _z.bankid = "TTY";
                }
                _z.text = _y[i].remark.trim() ? ("限额：" + (hk ? "不限额" : _y[i].remark)) : "";
                _z.label = _y[i].channelname + "（" + _y[i].bankcard + "）";
                _z.mobile = _y[i].mobile;
                if (!_x[_y[i].paycenterid]) {
                    _x[_y[i].paycenterid] = {};
                    _x[_y[i].paycenterid].label = _y[i].paycentername;
                    _x[_y[i].paycenterid].options = [];
                }
                _x[_y[i].paycenterid].options.push(_z);
            }
            let _index = 0;
            for (let list in _x) {
                if (_index === 0) {
                    bankLists[0].options[0].bankCate = _x[list].label;
                    bankLists[0].options = bankLists[0].options.concat(_x[list].options);
                    _index++;
                } else {
                    bankLists.push(_x[list]);
                }
            }
            if(bankLists.length === 1 && bankLists[0].options.length === 1){
                bankLists = [];
            }
        }
        return bankLists;
    },
    /* 提取对象某些值生成一个新对象
   @inParam [Object] obj 原对象
   @inParam [String] str 需要提取的参数，以逗号隔开
   @return [Object] 处理后的对象
   */
    getObjParam(obj, str) {
        if (str.toString() && str.indexOf(",") > -1) {
            const arr = str.split(",");
            let _obj = {};
            for (let i = 0; i < arr.length; i++) {
                _obj[arr[i]] = obj[arr[i]] || "";
            }
            return _obj;
        } else {
            return {
                str: obj[str] || ""
            };
        }
    },
    /* 根据传入的某个字段合并成一个新数组，并可以根据需要对里面的某些字段求和或以逗号隔开处理
   @param [Array] fundLists 原数组信息
   @param [Object] oparams 合并依赖和计算合并字段{code:'合并字段', noFilter:'不需要合并判断字段', noFilterVal:'不需要合并判断字段值', data:['求和字段','']}
   @param [Boolean] str 合并字段是否以逗号隔开
   @returns [Array] 返回合并后数据列表
   */
    getCodeOnly(fundLists, oparams, str) {
        let fundList = [];
        let temp = {};
        for (let i = 0; i < fundLists.length; i++) {
            let tempList = Object.assign({}, fundLists[i]);
            // 处理特殊数据
            if (
                oparams.noFilter &&
                tempList[oparams.noFilter] === oparams.noFilterVal
            ) {
                tempList.fundArr = [];
                tempList.fundArr.push(fundLists[i]);
                fundList.push(tempList);
                continue;
            }
            // 数据合并
            // 添加第一条数据
            if (!temp[tempList[oparams.code]] || !tempList[oparams.code].trim()) {
                temp[tempList[oparams.code]] = true;
                tempList.fundArr = [];
                tempList.fundArr.push(fundLists[i]);
                fundList.push(tempList);
            } else {
                // 合并其它相同数据
                for (let j in fundList) {
                    if (fundList[j][oparams.code] === tempList[oparams.code]) {
                        fundList[j].sourceflag = (fundList[j].sourceflag == "1" || tempList.sourceflag == "1") ? "1" : fundList[j].sourceflag;//合并数据时若持直销份额支持赎回
                        if (oparams.data && oparams.data.length > 0) {
                            const _m = Math.pow(10, 4);
                            for (let l = 0; l < oparams.data.length; l++) {
                                if (!str) {
                                    fundList[j][oparams.data[l]] =
                                        Math.round(
                                            (Number(fundList[j][oparams.data[l]]) +
                                                Number(fundLists[i][oparams.data[l]])) *
                                            _m
                                        ) / _m;
                                } else {
                                    if (fundLists[i][oparams.data[l]]) {
                                        if (fundList[j][oparams.data[l]]) {
                                            fundList[j][oparams.data[l]] +=
                                                "," + fundLists[i][oparams.data[l]];
                                        } else {
                                            fundList[j][oparams.data[l]] =
                                                fundLists[i][oparams.data[l]];
                                        }
                                    }
                                }
                            }
                        }

                        fundList[j].fundArr.push(tempList);
                        break;
                    }
                }
            }
        }
        return fundList;
    },
    /* 判断基金是否可以购买
   @param [String] status 基金状态信息
   @returns [String] 返回判断信息
   */
    checkBuy(status) {
        if (status === CommonConst.FS_OnIssue) {
            return false;
        }
        if (
            status === CommonConst.FS_OnTrade ||
            status === CommonConst.FS_OffRedeem ||
            status === CommonConst.FS_OnSetBal ||
            status === CommonConst.FS_OnDivdent
        ) {
            return "";
        } else {
            return "基金状态为" + cache.getDict("130011", status);
        }
    },
    /* 判断组合基金是否可以购买
   @param [String] status 组合基金状态信息
   @returns [String] 返回判断信息
   */
    checkComboBuy(status) {
        const temp = [
            CommonConst.FS_OnIssue,
            CommonConst.FS_IssueSucc,
            CommonConst.FS_IssueFail,
            CommonConst.FS_OffTrade,
            CommonConst.FS_OffBid,
            CommonConst.FS_CloseFund,
            CommonConst.FS_EndFund
        ];
        let canPurchase = true;
        let _x = "";
        for (let i in temp) {
            if (status.indexOf(temp[i]) > -1) {
                canPurchase = false;
                _x = temp[i];
                break;
            }
        }
        if (canPurchase) {
            return "";
        } else {
            return "组合当中包含状态为" + cache.getDict("130011", _x) + "的基金";
        }
    },
    /* 判断组合基金是否可以定投
   @param [String] fund 组合基金信息
   @returns [String] 返回判断信息
   */
    checkComboGeneral(fund) {
        const temp = [
            CommonConst.FS_OnIssue,
            CommonConst.FS_IssueFail,
            CommonConst.FS_OffTrade,
            CommonConst.FS_IssueSucc,
            CommonConst.FS_CloseFund,
            CommonConst.FS_EndFund
        ];
        let canPurchase = true;
        let _x = "";
        for (let i in temp) {
            if (fund.fundstatus.indexOf(temp[i]) > -1) {
                canPurchase = false;
                _x = temp[i];
                break;
            }
        }
        if (canPurchase) {
            for (let j in fund.fundArr) {
                if (fund.fundArr[j].fundbizflag.indexOf("1") === -1) {
                    canPurchase = false;
                    return "组合当中存在基金未开通定期定额交易手段";
                }
            }
            return "";
        } else {
            return "组合当中包含状态为" + cache.getDict("130011", _x) + "的基金";
        }
    },
    /* 判断基金是否可以定投
   @param [String] fund 组合基金信息
   @returns [String] 返回判断信息
   */
    checkGeneral(fund) {
        if (fund.fundbizflag && fund.fundbizflag.indexOf("1") > -1) {
            const status = fund.fundstatus;
            if (
                status === CommonConst.FS_OnIssue ||
                status === CommonConst.FS_IssueFail ||
                status === CommonConst.FS_OffTrade ||
                status === CommonConst.FS_CloseFund ||
                status === CommonConst.FS_EndFund ||
                status === CommonConst.FS_IssueSucc
            ) {
                return "基金状态为" + cache.getDict("130011", status);
            } else {
                return "";
            }
        } else {
            return "基金未开通定期定额交易手段";
        }
    },
    /* 判断基金是否可以预约购买
   @param [String] fund 基金信息
   @returns [String] 返回判断信息
   */
    checkOrderBuy(fund) {
        const status = fund.fundstatus;
        if (
            status === CommonConst.FS_OnTrade ||
            status === CommonConst.FS_OffRedeem ||
            status === CommonConst.FS_OnSetBal ||
            status === CommonConst.FS_OnDivdent
        ) {
            return "";
        } else {
            return "基金状态为" + cache.getDict("130011", status);
        }
    },
    /* 判断基金是否可以预约赎回
   @param [String] fund 基金信息
   @returns [String] 返回判断信息
   */
    checkOrderSell(fund) {
        const status = fund.status;
        if (
            status === CommonConst.FS_OnTrade ||
            status === CommonConst.FS_OffBid ||
            status === CommonConst.FS_OnSetBal ||
            status === CommonConst.FS_OnDivdent
        ) {
            return "";
        } else {
            return "基金状态为" + cache.getDict("130011", status);
        }
    },
    /* 判断基金是否可以转换
  @param [Object] obj 原数组信息
  @returns [String] 返回判断信息
  */
    checkSell(obj) {
        let t = ",不能赎回";
        if(obj.fundArr && obj.fundArr.every(item => item.paycenterid === conf.const.ZX_CENTER)){
            return "直销柜台购买产品需在直销柜台赎回";
        }
        if (obj.availablevol > 0) {
            if (obj.sourceflag === "2") {
                return "非直销渠道购买不能赎回";
            }
            const status = obj.fundstatus;
            if (
                status === CommonConst.FS_OnTrade ||
                status === CommonConst.FS_OffBid ||
                status === CommonConst.FS_OnSetBal ||
                status === CommonConst.FS_OnDivdent
            ) {
                return "";
            } else {
                return "基金状态为" + cache.getDict("130011", status) + t;
            }
        } else {
            return "基金可用份额为0" + t;
        }
    },
    /* 判断基金是否可以转换
  @param [Object] obj 原数组信息
  @returns [String] 返回判断信息
  */
    checkChange(obj) {
        if (obj.availablevol > 0) {
            if (obj.sourceflag === "2") {
                return "该基金为代销基金";
            }
            if (obj.sharetype === CommonConst.ST_Before) {
                const status = obj.fundstatus;
                if (
                    status === CommonConst.FS_OnTrade ||
                    status === CommonConst.FS_OffBid ||
                    status === CommonConst.FS_OnSetBal ||
                    status === CommonConst.FS_OnDivdent
                ) {
                    return "";
                } else {
                    return "基金状态为" + cache.getDict("130011", status);
                }
            } else {
                return "基金收费方式为" + cache.getDict("130000", obj.sharetype);
            }
        } else {
            return "基金可用份额为0";
        }
    },
    /* 获取产品适当性匹配信息
  @param [Object] _this Vue对象
 @param [Object] fund 待校验基金
 @param [Function] cb 回调方法
 */
    fundRiskCheck(_this, fund, cb) {
        // 判断用户是否已绑定交易账户
        const info = cache.getUser();
        this.getProfession((data)=>{
            const _x = Object.assign({},info,data);
            _this.$store.dispatch("setInfo", _x);
            if (
                info.usertype === "2" ||
                !info.tradingmethod ||
                info.tradingmethod.indexOf("2") === -1
            ) {
                Vue.prototype.$confirm(
                    "您的账户尚未认证，暂时无法进行购买/定投基金等交易功能，是否立即前往账户认证",
                    "交易手段信息提示", {
                        confirmButtonText: "前往",
                        cancelButtonText: "返回",
                        type: "warning",
                        customClass: "info-check"
                    }
                ).then(() => {
                    _this.$router.push({
                        name: "bindacctway"
                    });
                }).catch(() => {});
                return false;
            }
            if (info.lowriskflag === "1") {
                this.request("fund/detail",{fundcode: fund.fundcode}).then(res => {
                    if(res.data){
                        console.log(res.data[0].risklevel);
                        if(res.data[0].risklevel && res.data[0].risklevel !== "01"){
                            const h = _this.$createElement;
                            _this.$msgbox({
                                title: "最低风险提示",
                                message: h("div", null, [
                                    h(
                                        "span",
                                        null,
                                        "您当前为最低风险能力承受人，根据证监会销售适当性规定，您不可购买高于您风险等级的产品。 "
                                    )
                                ]),
                                showCancelButton: true,
                                confirmButtonText: "重新评测",
                                cancelButtonText: "暂不评测",
                                type: "warning",
                                customClass: "info-check",
                                beforeClose: (action, instance, done) => {
                                    if (action === "confirm") {
                                        _this.$router.push({
                                            name: "risktest"
                                        });
                                        done();
                                    } else {
                                        done();
                                    }
                                }
                            });
                            return false;
                        }else{
                            if (cb) {
                                cb.call(this, fund);
                            }
                        }
                    }
                });
            }else{
                if (cb) {
                    cb.call(this, fund);
                }
            }
        });
    },
    /* 获取产品适当性匹配信息
  @param [Object] _this Vue对象
 @param [Object] fund 待校验基金
 @param [Function] cb 回调方法
 */
    fundRiskCheckWeb(store, router, fund, cb) {
        // 判断用户是否已绑定交易账户
        const _this = this;
        const info = cache.getUser();
        this.getProfession((data) => {
            const _x = Object.assign({}, info, data);
            store.dispatch("setInfo", _x);
            if (
                info.usertype === "2" ||
                !info.tradingmethod ||
                info.tradingmethod.indexOf("2") === -1
            ) {
                Vue.prototype.$confirm(
                    "您的账户尚未认证，暂时无法进行购买/定投基金等交易功能，是否立即前往账户认证",
                    "交易手段信息提示", {
                        confirmButtonText: "前往",
                        cancelButtonText: "返回",
                        type: "warning",
                        customClass: "info-check"
                    }
                ).then(() => {
                    cb.call(this);
                    setTimeout(function(){
                        router.push({
                            name: "bindacctway"
                        });
                    },500);
                }).catch(() => {
                    _this.closeView();
                });
            }
            else if (info.lowriskflag === "1") {
                this.request("fund/detail",{fundcode: fund.fundcode}).then(res => {
                    if(res.data){
                        if(res.data[0].risklevel && res.data[0].risklevel !== "01"){
                            Vue.prototype.$confirm(
                                "您当前为最低风险能力承受人，根据证监会销售适当性规定，您不可购买高于您风险等级的产品。",
                                "最低风险提示", {
                                    confirmButtonText: "重新评测",
                                    cancelButtonText: "暂不评测",
                                    type: "warning",
                                    customClass: "info-check"
                                }
                            ).then(() => {
                                cb.call(this);
                                setTimeout(function(){
                                    router.push({
                                        name: "risktest"
                                    });
                                },500);
                            }).catch(() => {
                                _this.closeView();
                            });
                            return false;
                        }else{
                            this.getSdxProtocol(fund,val=>{
                                if (val && cb) {
                                    cb.call(this, fund);
                                }
                            });

                        }
                    }
                });
            }else{
                this.getSdxProtocol(fund,val=>{
                    if (val && cb) {
                        cb.call(this, fund);
                    }
                });
            }
        });
    },
    closeView() {
        window.close();
    },
    /* 获取产品适当性匹配信息
  @param [Object] _this Vue对象
 @param [Object] fund 待校验基金
 @param [Function] cb 回调方法
 */
    getSdxProtocol(fund, cb) {
        // 绑定交易账户做适当性判断
        this.request("acct/sdx/check", { fundcode: fund.fundcode }, "POST").then(res => {
            if (res.data) {
                const data = res.data[0];
                if (data) {
                    // 查询协议
                    if (fund.proto) {
                        // 查询协议
                        this.getProtocol(fund.proto).then(res => {
                            data.protoArr = res;
                            // 适当性校验规则
                            if (
                                data.fundmismatchflag === "1" ||
                                data.riskwarnflag === "1" ||
                                data.riskmismatchflag === "1" ||
                                data.highriskwarnflag === "1" ||
                                data.protoArr.length > 0
                            ) {
                                fund.sign = true;
                            }
                            fund = Object.assign(fund, data);
                            if (cb) {
                                cb.call(this, fund);
                            }
                        });
                    } else {
                        fund = Object.assign(fund, data);
                        if (cb) {
                            cb.call(this, fund);
                        }
                    }
                }
            }
        });
    },
    /* 获取风险匹配class名
  @param [String] risk 风险值
  @return [String] 匹配的class名称
  */
    riskCla(risk) {
        let cla = "";
        switch (risk) {
        case "01":
            cla = "low";
            break;
        case "02":
            cla = "median-low";
            break;
        case "03":
            cla = "median";
            break;
        case "04":
            cla = "median-high";
            break;
        case "05":
            cla = "high";
            break;
        default:
            break;
        }
        return cla;
    },
    /* 获字符串过滤
  @param [String] val 过滤值
  @return [String] 过滤后的字符串
  */
    filterNum(val) {
        return val.replace(/[^0-9]/g, "");
    },
    /* 获取模糊搜索支行信息
   @inParam [Object] _this Vue实例对象
   @inParam [String] queryString 搜索字符串
   @inParam [String] bankid 银行卡ID
   @inParam [Function] cb 回调函数
   */
    querySearch(_this, queryString, bankid, cb) {
        let _z = [];
        const _str = this.filterCode(queryString);
        _this.$set(_this.acctInfo, "bankname", _str);
        clearTimeout(_this.query);
        _this.query = setTimeout(function() {
            _this.$util
                .request(
                    "common/bankbranch&", {
                        cityname: _this.acctInfo.city,
                        bankid: bankid,
                        keyword: _str
                    },
                    false,
                    false
                )
                .then(res => {
                    if (res.data) {
                        _this.branchList = res.data;
                        if (cb) {
                            _z = _this.branchList.map(arr => {
                                let _x = {};
                                _x.value = arr.branchname;
                                _x.adress = arr.exchangecode;
                                return _x;
                            });
                            cb(_z);
                        }
                    }
                });
        }, 500);
    },
    /* 根据省代码获取对应城市信息
  @inParam [Object] _this Vue实例对象
  @inParam [String] val 取得的省市值
  @inParam [Function] cb 回调函数
  */
    getCity(val, cb) {
        if (val && val !== "") {
            req({
                method: "GET",
                url: "common/citylist",
                params: {
                    provinceid: val
                }
            }).then(res => {
                if (res.code === "0000000") {
                    if (cb) {
                        cb.call(this, res.record[0]);
                    }
                }
            }).catch(() => {});
        }
    },
    /* 获取对应风险描述信息
   @inParam [String] risk 风险代码
   @return [String] val 风险描述信息
   */
    getRiskTest(risk) {
        const riskInfo = CommonConst.RISK_INFO;
        const _x = riskInfo.filter(item => {
            return item.risk === risk;
        });
        return _x[0].describe;
    },
    /* 获取基金风险过滤信息
  @inParam [String] status 过滤标志
  @return [String] val 风险过滤信息
  */
    riskFilter(status) {
        return status !== "1" ?
            CommonConst.FUND_RISK_INFO :
            CommonConst.FUND_HIGHRISK_INFO;
    },
    /* 监测是否开启大写锁定
  @return [String] 是否开启大写锁定
  */
    detectCapsLock() {
        // 大写标志获取
        let capital = sessionStorage.getItem("capital");
        // 无值赋值为0
        if (capital !== "1") {
            capital = "0";
        }
        // 全局事件监听
        let e = event || window.event;
        let keyCode = e.keyCode || e.which; // 按键的keyCode
        let isShift = e.shiftKey || keyCode === 16 || false; // shift键是否按住
        // 是否点击大小切换按钮
        if (keyCode === 20) {
            capital = capital === "1" ? "0" : "1";
        } else if (e.key && e.key.length === 1) {
            // 获取输入字符是否是大写
            if (
                (/[A-Z]/.test(e.key) && !isShift) || // Caps Lock 打开，且没有按住shift键
                (/[a-z]/.test(e.key) && isShift) // Caps Lock 打开，且按住shift键
            ) {
                capital = "1";
            } else if (/[a-z]{1,2}$/.test(e.key)) {
                capital = "0";
            }
        }
        sessionStorage.setItem("capital", capital);
        return capital === "1";
    },
    /* 处理银行卡卡号4位添加空格
  @inParam [String] val 待处理银行卡卡号
  @return [String] 处理后的银行卡号码
  */
    getNewCard(val) {
        const _z = val.length / 4;
        let _new = "";
        for (let i = 0; i < _z; i++) {
            _new += val.substr(4 * i, 4) + "  ";
        }
        return _new.trim();
    },
    /* 处理银行卡卡号4位添加空格
  @inParam [String] val 待处理银行卡卡号
  @return [String] 处理后的银行卡号码
  */
    getDimCard(val) {
        return val.slice(0, -11) + "******" + val.slice(-5);
    },
    /* 计算某个时间前的时间
 @inParam [String] date 时间依据格式20001010
 @inParam [String] num 表示多少月或多少年之前
 @inParam [String] y 表示是否是计算年
 @return [String] 处理后的时间
 */
    getBeginDate(date, num, y) {
        if (num && num !== +num) return;
        let _r = "";
        if (y) {
            _r = (date.substr(0, 4) - num).toString() + date.substr(4);
        } else {
            const _m = Math.floor(num / 12);
            const _o = num % 12;
            const _mo = date.substr(4, 2) - _o;
            if (_mo > 0) {
                _r =
                    date.substr(0, 4) -
                    _m +
                    (_mo > 9 ? _mo : "0" + _mo).toString() +
                    date.substr(6);
            } else {
                _r =
                    date.substr(0, 4) -
                    _m -
                    1 +
                    (_mo < -2 ? "0" + (12 + _mo) : 12 + _mo).toString() +
                    date.substr(6);
            }
        }
        // 处理闰年
        const _rm = _r.substr(4, 2);
        if (_rm === "02" && _r.substr(6, 2) > 28) {
            const _y = _r.substr(0, 4);
            if ((_y % 4 === 0 && _y % 100 !== 0) || _y % 400 === 0) {
                _r = _r.substr(0, 6) + "29";
            } else {
                _r = _r.substr(0, 6) + "28";
            }
            // 处理特殊月份值
        } else if ("04,06,09,11".indexOf(_rm) > -1) {
            if (_r.substr(6, 2) > 30) {
                _r = _r.substr(0, 6) + "30";
            }
        }
        return _r;
    },
    /* 获取费率
  @inParam [String] fund 基金信息
  @inParam [String] cb 回调函数
  */
    getFee(fund, cb) {
        clearTimeout(queryRate);
        if (fund === null) return cb.call(this, {});
        queryRate = setTimeout(() => {
            this.request("trade/fee", fund, "GET", false).then(res => {
                if (res.data && cb) {
                    cb.call(this, res.data[0]);
                }
            });
        }, 500);
    },
    //判断一个值是否是 null||undefined||空字符串
    isEmpty(value) {
        if (value === null || value === undefined) return true;
        if(typeof value !== "string"){
            return false;
        }
        value = value.trim();
        if (value === "" || value === " ") {
            return true;
        } else {
            return false;
        }
    },
    /* 给数据添加一个唯一标识值
 @inParam [Object] data 基金信息
 @return [String] 组装后的数据
 */
    dataTaacFilter(data){
        if(!(data && data.fundArr && data.fundArr.length > 0))return;
        const _x = data.fundArr;
        let _arr = [];
        for(let i in _x){
            _x[i].index = i + "";
            _arr.push(_x[i]);
        }
        data.fundArr = _arr;
        return data;
    },
    /**
     * 调转到网站
     *
    */
    toCompPage(url,params){
        let _url = cache.getCompanyInfo().companywebsite || "";
        if (_url && _url.indexOf("${fundcode}") > -1) {
            var fundcode = params.secondtype;
            _url = new Function("fundcode","return `" + _url + "`;")(fundcode);
            window.open(_url,"_blank");
        }else {
            let _x = "?location=jweb";
            //没有对应的4.0网站，ump不配置，网交不做跳转
            if (this.isEmpty(_url)) {
                return;
            }
            //配置地址如下 "http://192.168.8.77:8081/agate/jfit/#"
            if(!(_url.indexOf("https://") > -1 || _url.indexOf("http://") > -1)){
                Vue.prototype.$alert("基金公司配置跳转地址有误，请联系基金公司修改！", "跳转网上交易提示", {
                    confirmButtonText: "确定",
                    type: "warning"
                });
                return;
            }
            const _y = _url.substr(_url.length - 1,1);
            if(_y === "/"){
                _url = _url.substr(0,_url.length - 1);
            }
            if(params){
                Object.keys(params).forEach(key=>{
                    _x += "&" + key + "=" + params[key];
                });
            }
            let openUrl = _url + url + _x;
            window.open(openUrl,"_blank");
        }
    },
    /*信息披露 获取带阅读文件*/
    queryReadFileInfo (data,cb){
        this.getGtParamsValue ("1001164",res => {
            if(res.paramvalue.indexOf("A94") > -1) {
                this.request(
                    "readfile",
                    data,
                    "GET").then(res => {
                    if (res.data) {
                        cb.call(this,res.data || "");
                    }else {
                        cb.call(this,"");
                    }
                });
            }else {
                cb.call(this,"");
            }
        });

    },
    /**
     * 留痕信息接口
     */
    writeFileInfo(data,cb) {
        if(data.readFileInfoList.length === 0){
            return cb.call(this,"");
        }
        var version = "", textname = "", textno = "", texttype = "";
        for (var i = 0; i < data.readFileInfoList.length; i++) {
            version += data.readFileInfoList[i].version + ",";
            textname += data.readFileInfoList[i].textname + ",";
            textno += data.readFileInfoList[i].textno + ",";
            texttype += data.readFileInfoList[i].texttype + ",";
        }
        this.request("readfile/record",{
            "fundcode": data.fundcode,
            "version": version.substring(0, version.length - 1),
            "tano": data.tano,
            "textname": textname.substring(0, textname.length - 1),
            "textno": textno.substring(0, textno.length - 1),
            "acceptmethod": "2",
            "texttype": texttype.substring(0, texttype.length - 1).replace(/\s/g,"")
        },
        "POST").then(res => {
            if (res.data) {
                cb.call(this,res.data[0].appsheetserialno || "");
            }else {
                cb.call(this,"");
            }
        });
    },
    initPwdCheckText(){
        const _p = cache.getCompanyInfo();
        let _x = "";
        if (_p.pwdneednumber === "1") {
            _x += "必须包含数字、";
        }
        if (_p.pwdneedword === "1") {
            _x += "必须包含字母、";
        }
        if (_p.pwdneedupperletter === "1") {
            _x += "必须包含大小写字母、";
        }
        if (_p.pwdnotcontinu === "1") {
            _x += "不能有2个以上连续的数字和字母";
        }
        if(_x === ""){
            return "密码必须为6-16位字母或数字";
        }else{
            return "密码规则为" + _x + "的6-16位字符";
        }
    },
    initTPwdCheckText(){
        return "密码规则为6-16位纯数字，不能含有三个连续相同的字符，不能含有三个或三个以上的连续字符";
    },
    initQryPwdCheckText(){
        return "密码规则为6位纯数字，不能含有三个连续相同的字符，不能含有三个或三个以上的连续字符";
    },
    convertArrToObj(arr,key1,key2){//[{"key1":"val1","key2":"val2"},...] => {"val1":"val2,...}
        if(!(arr instanceof Array)){
            return {};
        }
        let obj = {};
        arr.forEach(item => {
            if(!item[key1] || !item[key2]){
                return {};
            }
            obj[item[key1]] = item[key2];

        });
        return obj;
    },
    checkInfoFilled(obj,excludeItems){//判断{}必填项是否有值
        if(!obj){
            return true;
        }
        if(!excludeItems || excludeItems.length == 0){
            excludeItems = [];
        }
        for(let pro in obj){
            if(excludeItems.some( item => item === pro)){
                continue;
            }
            if(this.isEmpty(obj[pro]))
                return false;
        }
        return true;
    },
    highriskareaquery (country, location, cb){
        var belongregion = "";
        if (country == "CN" || country == "156") {
            belongregion = cache.getDict("120120","0");
        } else {
            belongregion = cache.getDict("120120","1");
        }
        const _param = {
            "belongregion": belongregion,
            "location": location
        };
        this.request("orgopen/search/highrisk",_param,"GET").then(res=>{
            if(res.data) {
                cb.call(this,res.data[0].highriskfalg || "");
            }
        });
    },
    specificnaturalper (param, cb){
        this.request("anon/querySpecialPer",param,"GET").then(res=>{
            if(res.data) {
                cb.call(this,res.data[0] || "");
            }
        });
    },
    adddigniaryorceo (param){
        this.request("anon/saveBeneficiary",param,"POST").then(res=>{

        });
    },
    /**
     * 字典将指定值挪到第0位置
     */
    changeArrIndex (arr, id) {
        let index = 1, newArr = [], length = arr.length;
        for (let i = 0; i < length; i++){
            if (arr[i].subitem == id){
                newArr[0] = arr[i];
            }
            else{
                newArr[index++] = arr[i];
            }
        }
        return newArr;
    },
    getGtParamsValue (paraid, cb) {
        let data = {
            "paramtype": "1",
            "paramname": paraid
        };
        this.request("common/param", data, "GET").then(res => {
            if (res.data && cb) {
                cb.call(this, res.data[0]);
            }
        });
    },
    getOcrOpenStatus (cb) {
        this.request("/acct/ocr/check", {}, "GET").then(res => {
            if (res.data && cb) {
                cb.call(this, res.data[0]);
            }
        });
    },
    /* 根据柜台开关判断业务是否需要校验ocr状态
    */
    checkGtOcrModule (id, flag, cb) {
        let paraid = "";
        let checkFlag = false;
        if (flag == "0") {
            paraid = "6000300";
        } else if (flag == "1") {
            paraid = "6000301";
        }
        this.getOcrOpenStatus(res => {
            if (res.isOpenOcr == "1") {
                this.getGtParamsValue (paraid, res => {
                    if (paraid == "6000300") {
                        if (!(res.paramvalue.indexOf(id) > -1)) {
                            checkFlag = true;
                        }
                    } else if (paraid == "6000301") {
                        if (res.paramvalue.indexOf(id) > -1) {
                            checkFlag = true;
                        }
                    }
                    cb.call(this, {"checkFlag": checkFlag});
                });
            }else {
                cb.call(this, {"checkFlag": checkFlag});
            }
        });
    }
};
